import useEventListener from '@use-it/event-listener';
import { useState } from 'react';
import screenfull from 'screenfull';
import { sendAnalyticsEvent } from 'src/lib/googleAnalytics';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

export default function FullscreenControl(): JSX.Element {
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isEnabled && screenfull.isFullscreen);

  function handleFullscreenChange() {
    setIsFullscreen(screenfull.isFullscreen);
  }

  useEventListener(screenfull.raw.fullscreenchange, handleFullscreenChange, document);
  useEventListener(screenfull.raw.fullscreenerror, handleFullscreenChange, document);

  async function handleClick() {
    sendAnalyticsEvent('fullscreen-click');
    await screenfull.toggle(document.body);
    setIsFullscreen(screenfull.isFullscreen);
  }

  return (
    <div className="mapboxgl-ctrl-group">
      <button
        className="mapboxgl-ctrl-icon"
        title={t('Fullscreen')}
        {...onClickGenerator(handleClick)}
      >
        {isFullscreen ? <i className="fas fa-compress" /> : <i className="fas fa-expand" />}
      </button>
    </div>
  );
}
